import React from "react";
import { Link, useParams } from "react-router-dom";
import request from "src/utils/request";
import { useAuth } from "./providers/auth-context";
import { useActiveIntegrationsTeams } from "../scenes/teams/dashboard/active-integrations-provider-teams";
import DemoBar from "./demo-bar";
import { useTeam } from "../scenes/teams/team/team-provider";

const DemoBarTeam = () => {
    const { teamId } = useParams();
    const { isLoading, userHasTeamsSubscription, isDemo, isUserPayingCustomer } = useAuth();
    const teamApi = useTeam();

    const noTeamMembers =
        teamApi.data && (!teamApi.data.members || teamApi.data.members.length === 0);

    const { activeIntegrations } = (teamId && useActiveIntegrationsTeams()) || {};

    if (isLoading) return null;
    if (isDemo || !isUserPayingCustomer) return null;

    const anyActiveIntegration =
        !teamId ||
        !activeIntegrations ||
        !activeIntegrations.data ||
        activeIntegrations.data.integrations.find((int) => int.connected);

    if (userHasTeamsSubscription && anyActiveIntegration && !noTeamMembers) return null;

    React.useEffect(() => {
        if (!userHasTeamsSubscription || !anyActiveIntegration || noTeamMembers) {
            request(`/api/users/me/achievements`, {
                method: "POST",
                body: JSON.stringify(["visitDemoTeams"]),
            });
        }
    }, [userHasTeamsSubscription && anyActiveIntegration && !noTeamMembers]);

    const getUpgradeTo = () => {
        if (!userHasTeamsSubscription)
            return (
                <>
                    <Link to="/upgrade" style={{ color: "#7c1374" }}>
                        Upgrade
                    </Link>{" "}
                    to a <strong>Teams</strong> license to enable functionality.
                </>
            );
        if (noTeamMembers)
            return (
                <>
                    <Link to={`/teams/${teamId}`} style={{ color: "#7c1374" }}>
                        Add Members
                    </Link>{" "}
                    to the team to enable functionality.
                </>
            );
        if (!anyActiveIntegration)
            return (
                <>
                    <Link to="/setup-wizard" style={{ color: "#7c1374" }}>
                        Get started here
                    </Link>{" "}
                    and quickly manage you onboarding by using the setup wizard.
                </>
            );
        return null;
    };

    return (
        <DemoBar>
            You are currently on <strong>Demo Mode</strong>. {getUpgradeTo()}
        </DemoBar>
    );
};

export default DemoBarTeam;
